













import { Component, Prop, Vue } from 'vue-property-decorator'
import { State, Mutation, Action } from 'vuex-class'
@Component
export default class TagSearch extends Vue {
    @Prop() private msg!: string
    @Mutation setActiveTab
    @Mutation setTagIndex
    @Action getSearchArticle
    @State tagIndex
    @State pageTags
    componentName = 'zwl-template-tagSearch'
    searchContent: string = ''
    handleSelectByTag (index, content) {
      this.searchContent = content
      if (!this.searchContent) return false
      this.setActiveTab({})
      this.setTagIndex(index)
      this.getSearchArticle(this.searchContent)
      return true
    }
}
